import React from "react";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ReactSlider from "react-slick";
import b1 from '../../assets/images/BanerHome/b1.jpg'
import b2 from '../../assets/images/BanerHome/b2.jpg'

export default function Slider({ arr, sp }) {
  const settings = {
    dots: false,
    infinite: true,
    rtl: true,
    speed: 700,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1
  };

  const slidersImgs = [b1,b2];
  // const slidersImgs = ["/img/slider/1.jpg", "/img/slider/2.jpg", "/img/slider/3.webp", "/img/slider/4.webp",b1];

  return (

    <ReactSlider {...settings}>
      {!sp && slidersImgs.map(item => (
        <div>
          <img src={item} width={"100%"} alt={`رزرو استخر، رزرو باشگاه بدنسازی، رزرو سالن ورزشی`} />
        </div>
      ))}
      {sp && sp.map(item => (
        <div>
          <img src={item} width={"100%"} alt={`رزرو استخر، رزرو باشگاه بدنسازی، رزرو سالن ورزشی`} />
        </div>
      ))}
    </ReactSlider>
  );
}


